"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _events = _interopRequireDefault(require("../utils/events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ClickOutside =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ClickOutside, _React$Component);

  function ClickOutside() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ClickOutside);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ClickOutside)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.isTouch = false;
    _this.container = void 0;

    _this.getContainer = function (node) {
      _this.container = node;
    };

    _this.handle = function (event) {
      if (event.type === 'touchend') {
        _this.isTouch = true;
      }

      if (event.type === 'click' && _this.isTouch) return;
      var _this$props = _this.props,
          onClickOutside = _this$props.onClickOutside,
          ignoredNode = _this$props.ignoredNode;
      var el = _this.container;
      if (ignoredNode && ignoredNode.contains(event.target)) return;
      if (el && !el.contains(event.target)) onClickOutside(event);
    };

    return _this;
  }

  _createClass(ClickOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var disabled = this.props.disabled;

      if (!disabled) {
        this.bindEvent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var disabled = this.props.disabled;

      if (prevProps.disabled !== disabled) {
        if (disabled) {
          this.unBindEvent();
        } else {
          this.bindEvent();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var disabled = this.props.disabled;

      if (!disabled) {
        this.unBindEvent();
      }
    }
  }, {
    key: "bindEvent",
    value: function bindEvent() {
      _events.default.on(document, 'click', this.handle);

      _events.default.on(document, 'touchend', this.handle);
    }
  }, {
    key: "unBindEvent",
    value: function unBindEvent() {
      _events.default.off(document, 'click', this.handle);

      _events.default.off(document, 'touchend', this.handle);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClickOutside = _this$props2.onClickOutside,
          disabled = _this$props2.disabled,
          children = _this$props2.children,
          ignoredNode = _this$props2.ignoredNode,
          rest = _objectWithoutProperties(_this$props2, ["onClickOutside", "disabled", "children", "ignoredNode"]);

      return _react.default.createElement("div", _extends({
        ref: this.getContainer
      }, rest), children);
    }
  }]);

  return ClickOutside;
}(_react.default.Component);

exports.default = ClickOutside;
ClickOutside.propTypes = {
  onClickOutside: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool
};
ClickOutside.defaultProps = {
  disabled: false
};